import React from 'react';
import Dropdown from '../Dropdown';
import BedsBathsFilter from 'common/components/BedBathFilter';
import Button from 'common/components/Button';
import useFiltersStore from '_viewport-maps/src/store/useFiltersStore';
import { filterDefaults, sendCloseDropdownEvent } from '_viewport-maps/src/util/filters';
import settings from '_viewport-maps/src/util/config';
import { BUTTON_TYPES } from 'common/types/forms';
const BedsBathsDropdown = () => {
    const { beds, setBeds, resetBeds, baths, setBaths, resetBaths, setApplyFilterFlag } = useFiltersStore();
    return (React.createElement(Dropdown, { toggleClass: "filter-dropdown", toggleChildren: React.createElement(React.Fragment, null,
            React.createElement("span", { className: "filter-dropdown__label" }, beds === filterDefaults.beds && baths === filterDefaults.baths
                ? settings.FilterBedsAndBathLabel
                : `${beds}+${settings.BedsSuffix} / ${baths}+${settings.BathsSuffix}`),
            React.createElement("i", { className: "filter-dropdown__symbol fas fa-angle-down" })), contentClass: "filter-dropdown__content" },
        React.createElement(BedsBathsFilter, { title: settings.FilterBedsAndBathLabel, beds: beds, bedsLabel: settings.FilterBedroomsLabel, onBedsChange: (beds) => setBeds(beds), baths: baths, bathsLabel: settings.FilterBathroomsLabel, onBathsChange: (baths) => setBaths(baths), className: "viewport-map__beds-baths-filter" }),
        React.createElement("hr", { className: 'filter-horizontal-divider' }),
        React.createElement("div", { className: "flex-between viewport-map__filters__buttons" },
            React.createElement(Button, { type: BUTTON_TYPES.BUTTON_LINK, className: "viewport-map__filters__clear-button", onCLick: (event) => {
                    resetBeds();
                    resetBaths();
                    sendCloseDropdownEvent(event.target);
                } }, settings.FilterClearLabel),
            React.createElement(Button, { type: BUTTON_TYPES.BUTTON_PRIMARY_SMALL, className: "viewport-map__filters__save-button", onCLick: (event) => {
                    if (beds === 0) {
                        setBeds(1);
                    }
                    if (baths === 0) {
                        setBaths(1);
                    }
                    setApplyFilterFlag(true);
                    sendCloseDropdownEvent(event.target);
                } }, settings.FilterSaveLabel))));
};
export default BedsBathsDropdown;
